import dayjs from 'dayjs'
import xhr from 'xhr'

const PAGE_SIZE = 250

const inFilter = (field, ids) => ids.map((id, index) => `filters${field}[$in][${index}]=${id}`).join('&')

/**
 * Fecha del último registro de historial de cada prospecto. Devuelve
 * { [prospectId]: fechaISO }. Los prospectos sin historial no aparecen.
 */
export async function loadLastContacts(prospects) {
  const ids = prospects.map((el) => el.id)
  if (!ids.length) return {}

  const base =
    `/prospect-histories?${inFilter('[prospect][id]', ids)}` +
    `&fields[0]=createdAt&populate[prospect][fields][0]=id&sort[0]=createdAt:desc&pagination[pageSize]=${PAGE_SIZE}`

  // Strapi entrega máximo 250 por consulta: se recorren las páginas por si
  // algún prospecto tiene un historial muy largo.
  const first = await xhr(`${base}&pagination[page]=1`)
  const pageCount = first.data.meta?.pagination?.pageCount || 1
  const rest = await Promise.all(
    Array.from({ length: pageCount - 1 }, (_, i) => xhr(`${base}&pagination[page]=${i + 2}`))
  )

  const last = {}
  ;[first, ...rest]
    .flatMap((res) => res.data.data)
    .forEach((history) => {
      const prospectId = history.prospect?.id
      if (!prospectId) return
      if (!last[prospectId] || dayjs(history.createdAt).isAfter(last[prospectId])) last[prospectId] = history.createdAt
    })
  return last
}

export const daysSince = (date) => dayjs().startOf('day').diff(dayjs(date).startOf('day'), 'day')

export const relativeDays = (days) => {
  if (days <= 0) return 'hoy'
  if (days === 1) return 'ayer'
  return `hace ${days} días`
}

// Verde: contactado hoy o ayer. Amarillo: 2 a 4 días. Rojo: 5 días o más, o sin contacto.
export const contactColor = (days) => {
  if (days === null || days >= 5) return 'red'
  if (days >= 2) return 'yellow'
  return 'green'
}
